import '../assets/css/mobileMenu.css';
import { GoPlus } from "react-icons/go";
import { GiHamburgerMenu } from "react-icons/gi";

import { TiHomeOutline } from "react-icons/ti";
import { FaRegAddressCard } from "react-icons/fa";
// import { FaToolbox } from "react-icons/fa6";
import { PiToolbox } from "react-icons/pi";
import { IoRocketOutline } from "react-icons/io5";
import { LiaBusinessTimeSolid } from "react-icons/lia";
import { CiFileOn } from "react-icons/ci";
import { FaRegNewspaper } from "react-icons/fa6";
import { FaRegAddressBook } from "react-icons/fa";

import { useRef } from 'react';
import { Link } from 'react-router-dom';


const MobileMenu = () => {

    const menuToggle = useRef(null);
    const menu = useRef(null);
    const hamburger = useRef(null);
    const mMenuContainer = useRef(null);
    const mmcontainer = useRef(null);
    const menuToggleClickHandler = () => {



        if (!menu.current.classList.contains('active')) {
            hamburger.current.style.display = "none";
            // mMenuContainer.current.style.display = "flex";
            // mMenuContainer.current.style.left = "0px";
            mmcontainer.current.style.height = "100%";
            mMenuContainer.current.style.transform = "translateX(0px)";
            setTimeout(() => {
                menu.current.classList.toggle('active');
            }, 100);

        }
        else {
            menu.current.classList.toggle('active');
            setTimeout(() => {
                hamburger.current.style.display = "inline";
                // mMenuContainer.current.style.left = "100%";
                mMenuContainer.current.style.transform = "translateX(100%)";

                setTimeout(() => mmcontainer.current.style.height = "auto", 200);


                // mMenuContainer.current.style.display = "none";
            }, 1300);

        }






    }

    return (
        <div className='mobile_menu_container' ref={mmcontainer}>
            <span onClick={menuToggleClickHandler} className='hamburger' ref={hamburger}><span><GiHamburgerMenu /></span></span>
            <div className='mm_body' ref={mMenuContainer}>
                <ul className='menu' ref={menu}>
                    <div className='menuToggle' ref={menuToggle} onClick={menuToggleClickHandler}><GoPlus /></div>
                    <li style={{ '--i': 0, '--clr': '#ff2972' }} onClick={menuToggleClickHandler}>
                        <Link to="/"><TiHomeOutline className='my_icon' /></Link>
                    </li>
                    <li style={{ '--i': 1, '--clr': '#fee800' }} onClick={menuToggleClickHandler}>
                        <Link to="/about"><FaRegAddressCard className='my_icon' /></Link>
                    </li>
                    <li style={{ '--i': 2, '--clr': '#04fc43' }} onClick={menuToggleClickHandler}>
                        <Link to="/skills"><PiToolbox className='my_icon' /></Link>
                    </li>
                    <li style={{ '--i': 3, '--clr': '#fe00f1' }} onClick={menuToggleClickHandler}>
                        <Link to="/projects"><IoRocketOutline className='my_icon' /></Link>
                    </li> 
                    <li style={{ '--i': 4, '--clr': '#00b0fe' }} onClick={menuToggleClickHandler}>
                        <Link to="/experience"><LiaBusinessTimeSolid className='my_icon' /></Link>
                    </li>
                    <li style={{ '--i': 5, '--clr': '#fea600' }} onClick={menuToggleClickHandler}>
                        <Link to="/resume"><CiFileOn className='my_icon' /></Link>
                    </li>
                    <li style={{ '--i': 6, '--clr': '#a529ff' }} onClick={menuToggleClickHandler}>
                        <Link to="/blogs"><FaRegNewspaper className='my_icon' /></Link>
                    </li>
                    <li style={{ '--i': 7, '--clr': '#01bdab' }} onClick={menuToggleClickHandler}>
                        <Link to="/contact"><FaRegAddressBook className='my_icon' /></Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default MobileMenu;